import Vue from 'vue'
import Router from 'vue-router'
import LayoutCustom from './layouts/LayoutCustom.vue'
import CustomEventIndex from './components/events/custom/CustomEventIndex'
import CustomEventShow from './components/events/custom/CustomEventShow'
import CustomTicketPurchase from './components/events/custom/CustomTicketPurchase'
import CustomTicketPurchaseConfirmation from './components/events/custom/CustomTicketPurchaseConfirmation'
import CustomGiftCardShow from './components/gift_cards/custom/CustomGiftCardShow'
import CustomGiftCardPurchase from './components/gift_cards/custom/CustomGiftCardPurchase'
import CustomGiftCardPurchaseConfirmation from './components/gift_cards/custom/CustomGiftCardPurchaseConfirmation'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/events',
      component: LayoutCustom,
      children: [
        {
          path: '/events',
          name: 'customEventList',
          component: CustomEventIndex,
          meta: { requiresAuth: false }
        },
        {
          path: '/events/purchase-confirmation/:order_number',
          component: CustomTicketPurchaseConfirmation,
          name: 'customTicketPurchaseConfirmation',
          meta: { requiresAuth: false }
        },
        {
          path: '/events/:id/tickets-purchase',
          component: CustomTicketPurchase,
          name: 'customTicketPurchase',
          meta: {
            requiresAuth: false,
            modelType: 'Event'
          }
        },
        {
          path: '/events/:id/:event_title',
          name: 'customEventShow',
          component: CustomEventShow,
          meta: {
            requiresAuth: false,
            modelType: 'Event'
          }
        }
      ]
    },
    {
      path: '/gift-cards',
      component: LayoutCustom,
      children: [
        {
          path: '/gift-cards',
          name: 'customGiftCardList',
          component: CustomGiftCardShow,
          meta: { requiresAuth: false }
        },
        {
          path: '/gift-cards/purchase-confirmation/:order_number',
          component: CustomGiftCardPurchaseConfirmation,
          name: 'customGiftCardPurchaseConfirmation',
          meta: { requiresAuth: false }
        },
        {
          path: '/gift-cards/gift-card-purchase',
          component: CustomGiftCardPurchase,
          name: 'customGiftCardPurchase',
          meta: {
            requiresAuth: false,
            modelType: 'GiftCard'
          }
        }
      ]
    },
    {
      // Not found route
      path: '*',
      redirect: '/events'
    }
  ]
})
